<app-stages [stages]="stages" currentStage="Charakterystyka inwestycji"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-6'>
        <div class='form-group' *ngIf='"investmentName" as controlName'>
          <label [for]='controlName'>
            Nazwa inwestycji *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu nazwę inwestycji'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-4">
        <div class='form-group' *ngIf='"investmentAreaDesignation" as controlName'>
          <label [for]='controlName'>
            Sposób wyznaczenia terenu inwestycji *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option value='Teren inwestycji obejmuje całą działkę ewidencyjną lub działki ewidencyjne'>
              Teren inwestycji obejmuje całą działkę ewidencyjną lub działki ewidencyjne
            </option>
            <option value='Teren inwestycji obejmuje część działki ewidencyjnej lub działek ewidencyjnych'>
              Teren inwestycji obejmuje część działki ewidencyjnej lub działek ewidencyjnych
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"investmentAreaSize" as controlName'>
          <label [for]='controlName'>
            Powierzchnia terenu inwestycji, w przypadku gdy teren
            inwestycji obejmuje część co najmniej jednej <br> działki ewidencyjnej (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnie terenu inwestycji'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"existingDevelopment" as controlName'>
          <label [for]='controlName'>
            W przypadku gdy inwestycja dotyczy istniejącej zabudowy i zagospodarowania terenu,
            istniejąca zabudowa
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz dane istniejącej zabudowy'>
            </textarea>
          <app-validation-errors
            [showTextLength]="true"
            [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"currentLandUse" as controlName'>
          <label [for]='controlName'>
            Obecny sposób zagospodarowania terenu inwestycji *
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu w jaki sposób zagospodarowany teren'>
            </textarea>
          <app-validation-errors
            [showTextLength]="true"
            [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"plannedLandUse" as controlName'>
          <label [for]='controlName'>
            Projektowany sposób zagospodarowania terenu inwestycji *
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu projektowany sposób zagospodarowania'>
            </textarea>
          <app-validation-errors
            [showTextLength]="true"
            [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"impactDescription" as controlName'>
          <label [for]='controlName'>
            Sposób oddziaływania, w przypadku gdy obszar oddziaływania obiektu wykracza poza teren inwestycji
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu sposób oddziaływania'>
            </textarea>
          <app-validation-errors
            [showTextLength]="true"
            [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"environmentalImpactData" as controlName'>
          <label [for]='controlName'>
            Dane charakteryzujące wpływ inwestycji na środowisko, w szczególności określenie
            rodzaju przedsięwzięcia w nawiązaniu do przepisów odrębnych, w przypadku gdy
            inwestycja zalicza się do przedsięwzięć mogących znacząco oddziaływać na środowisko
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu dane charakteryzujące'>
            </textarea>
          <app-validation-errors
            [showTextLength]="true"
            [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend class="d-flex justify-content-center">
        Parametry dotyczące terenu inwestycji
      </legend>
      <fieldset>
        <legend>
          Powierzchnia zabudowy <small>(jeśli dotyczy)</small>
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"buildingAreaExisting" as controlName'>
              <label [for]='controlName'>
                Istniejąca (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu istniejącą powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"buildingAreaPlannedMin" as controlName'>
              <label [for]='controlName'>
                Projektowana, minimalna (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu projektowaną powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"buildingAreaPlannedMax" as controlName'>
              <label [for]='controlName'>
                Projektowana, maksymalna (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu projektowaną powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Powierzchnia biologicznie czynna <small>(jeśli dotyczy)</small>
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"biologicalAreaExisting" as controlName'>
              <label [for]='controlName'>
                Istniejąca (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu istniejącą powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"biologicalAreaPlannedMin" as controlName'>
              <label [for]='controlName'>
                Projektowana, minimalna (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu projektowaną powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"biologicalAreaPlannedMax" as controlName'>
              <label [for]='controlName'>
                Projektowana, maksymalna (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu projektowaną powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Powierzchnia podlegająca przekształceniu <small>(jeśli dotyczy)</small>
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"transformationAreaExisting" as controlName'>
              <label [for]='controlName'>
                Istniejąca (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu istniejącą powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"transformationAreaPlannedMin" as controlName'>
              <label [for]='controlName'>
                Projektowana, minimalna (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu projektowaną powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"transformationAreaPlannedMax" as controlName'>
              <label [for]='controlName'>
                Projektowana, maksymalna (m<sup>2</sup>)
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu projektowaną powierzchnie'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    </fieldset>
    <fieldset>
      <legend>
        Czy inwestycja dotyczy
      </legend>
      <br>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"isSmallHouse70m2" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                Wolnostojącego, nie więcej niż dwukondygnacyjnego budynku mieszkalnego
                jednorodzinnego o powierzchni zabudowy do 70 m², o którym mowa w art. 29 ust. 1 pkt
                1a ustawy z dnia 7 lipca 1994 r. – Prawo budowlane (Dz. U. z 2023 r. poz. 682, z późn. zm.)
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"isAgriculturalBiogas" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                Biogazowni rolniczej spełniającej warunki określone w art. 4 ust. 1 ustawy z dnia 13 lipca
                2023 r. o ułatwieniach w przygotowaniu i realizacji inwestycji w zakresie biogazowni
                rolniczych, a także ich funkcjonowaniu (Dz. U. poz. 1597)
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"isStrategicGridInvestment" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                Strategicznej inwestycji w zakresie sieci dystrybucyjnej, o której mowa w art. 1 ust. 2
                pkt 4a ustawy z dnia 24 lipca 2015 r. o przygotowaniu i realizacji strategicznych inwestycji
                w zakresie sieci przesyłowych (Dz. U. z 2023 r. poz. 1680, z późn. zm.)
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"isIndustrialHazardFacility" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                Zakładu o zwiększonym lub dużym ryzyku wystąpienia poważnej awarii przemysłowej,
                o którym mowa w art. 248 ust. 1 ustawy z dnia 27 kwietnia 2001 r. – Prawo ochrony
                środowiska (Dz. U. z 2024 r. poz. 54)
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <br>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"totalSalesOrUsableArea" as controlName'>
            <label [for]='controlName'>
              Łączna powierzchnia sprzedaży, w przypadku gdy inwestycja
              dotyczy obiektu handlowego (m<sup>2</sup>)
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu łączną powierzchnie'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"farmArea" as controlName'>
            <label [for]='controlName'>
              Powierzchnia gospodarstwa rolnego, w przypadku gdy
              inwestycja jest związana z gospodarstwem rolnym: (m<sup>2</sup>)
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu łączną powierzchnie'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"investmentAreaAdditionalInfo" as controlName'>
            <label [for]='controlName'>
              Dodatkowe informacje dotyczące terenu inwestycji
            </label>
            <textarea
              rows="3"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu dodatkowe informacje'>
            </textarea>
            <app-validation-errors
              [showTextLength]="true"
              [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
